import * as _ from "lodash";

export class SurveyQuestion {
    public sqid: number | null = null;
    public atid: number | null = null;
    public sid: number | null = null;
    public sqname = "";
    public atname = "";
    public required = 0;
    public choices: any[] = [];

    constructor(data?: any) {
        if (data) {
            this.setData(data);
        }
    }

    setData(data: any): void {
        _.merge(this, data);
    }
}
